module.exports = __webpack_public_path__ + "play-pause.png?a012413b54276e2eefd145c7aec60f93";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/play-pause.png
// module id = 525
// module chunks = 2